import {
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper
} from '@material-ui/core'

import { getTranslate } from '../../localization'
import useStyles from './styles/InventoryRestrictionSelector.styles'

export type Restrictions =
  | 'MasterStatus'
  | 'CTA'
  | 'CTD'
  | 'MinStay'
  | 'MaxStay'

export const BOOLEAN_RESTRICTIONS_LIST: {
  value: Restrictions
  label: string
}[] = [
  {
    label: getTranslate('Master Status'),
    value: 'MasterStatus'
  },
  {
    label: getTranslate('C.T.A'),
    value: 'CTA'
  },
  {
    label: getTranslate('C.T.D'),
    value: 'CTD'
  }
]

export const INPUT_RESTRICTIONS_LIST: {
  value: Restrictions
  label: string
}[] = [
  {
    label: getTranslate('Min Stay'),
    value: 'MinStay'
  },
  {
    label: getTranslate('Max Stay'),
    value: 'MaxStay'
  }
]

export const RESTRICTIONS_LIST: { value: Restrictions; label: string }[] = [
  ...BOOLEAN_RESTRICTIONS_LIST,
  ...INPUT_RESTRICTIONS_LIST
]

interface InventoryRestrictionSelectorProps {
  activeRestrictions: Record<
    Restrictions,
    { active: boolean; value?: boolean | string }
  >
  setActiveRestrictions: React.Dispatch<
    React.SetStateAction<
      Record<
        Restrictions,
        {
          active: boolean
          value?: string | boolean | undefined
        }
      >
    >
  >
}

const InventoryRestrictionSelector: React.FC<
  InventoryRestrictionSelectorProps
> = ({ activeRestrictions, setActiveRestrictions }) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root} elevation={5}>
      <List>
        <ListItem
          dense
          button
          onClick={() =>
            setActiveRestrictions(
              Object.values(activeRestrictions).filter((item) => item.active)
                .length === 5
                ? {
                    MasterStatus: { active: false },
                    CTA: { active: false },
                    CTD: { active: false },
                    MinStay: { active: false },
                    MaxStay: { active: false }
                  }
                : {
                    MasterStatus: { active: true },
                    CTA: { active: true },
                    CTD: { active: true },
                    MinStay: { active: true },
                    MaxStay: { active: true }
                  }
            )
          }>
          <ListItemIcon>
            <Checkbox
              indeterminate={
                Object.values(activeRestrictions).filter((item) => item.active)
                  .length !== 0 &&
                Object.values(activeRestrictions).filter((item) => item.active)
                  .length !== 5
              }
              edge="start"
              checked={
                Object.values(activeRestrictions).filter((item) => item.active)
                  .length === 5
              }
              color="primary"
              disableRipple
              inputProps={{ 'aria-labelledby': 'SelectAll' }}
            />
          </ListItemIcon>
          <ListItemText id="SelectAll" primary={getTranslate('Select All')} />
        </ListItem>
        {RESTRICTIONS_LIST.map((restrictionItem) => (
          <ListItem
            key={restrictionItem.value}
            dense
            button
            onClick={() =>
              setActiveRestrictions((currentActiveRestrictions) => ({
                ...currentActiveRestrictions,
                [restrictionItem.value]: {
                  ...currentActiveRestrictions[restrictionItem.value],
                  active:
                    !currentActiveRestrictions[restrictionItem.value].active
                }
              }))
            }>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={activeRestrictions[restrictionItem.value].active}
                color="primary"
                //   tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': restrictionItem.value }}
              />
            </ListItemIcon>
            <ListItemText
              id={restrictionItem.value}
              primary={getTranslate(restrictionItem.label)}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  )
}

export default InventoryRestrictionSelector
